module.exports = __webpack_public_path__ + "static/media/programmer.308a8770.svg";